import { ICalendarEvent, IScheduleCourses } from '../types/my_schedule_types';

import * as _4 from 'lodash4';

export class CourseScheduleLocalDatabase {
  private readonly courses: IScheduleCourses[] = [];

  constructor() {
    return this;
  }

  async addCourse(course: IScheduleCourses) {
    this.courses.push(course);
    return this.courses;
  }

  async addCourses(courses: ICalendarEvent[] | IScheduleCourses[]) {
    this.courses.concat(_4.toArray(courses));
    return this.courses;
  }

  async getCourses(argumentArray: string[]) {
    return this.courses.filter((item: any) => argumentArray.includes(item.nk));
  }

  async excludeCourses(argumentArray: object[]) {
    const nkArray = _4.map(argumentArray, (course: any) => course.nk) as string[];

    return this.courses
      .filter((item: any) => nkArray.includes(item.nk))
      .map((items: any) => {
        const dbNks: string[] = _4.map(items, (course: any) => course.nk) as string[];

        return _4.filter(argumentArray, (calObj: any) => !dbNks.includes(calObj.nk));
      });
  }

  async hasCourse(courseNk: string) {
    const dbCourseCount: any = await this.courses
      .filter((storedCourse: any) => courseNk === storedCourse.nk)
      .reduce((sum) => sum + 1, 0);

    return dbCourseCount > 0;
  }

  async hasAllCourses(schedule: object[]) {
    const argumentNkArray: string[] = _4.map(schedule, (course: any) => course.nk) as string[];
    const dbCourseArray: any = await this.getCourses(argumentNkArray);
    const dbNkArray: any = _4.uniq(_4.map(dbCourseArray, (item: any) => item.nk));

    return dbNkArray.length === argumentNkArray.length;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/databases/course_schedule_database.ts